module.exports = __webpack_public_path__ + "static/assets/095d9e7c2ecd2d9ea9695e258ec3874a.png";